// src/StackIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StackIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "19",
    height: "20",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.4974 3.17973L11.0573 0.756764C10.2589 0.403995 9.05209 0.403995 8.25372 0.756764L2.81365 3.17973C1.43971 3.79243 1.23548 4.62794 1.23548 5.07354C1.23548 5.51915 1.43971 6.35465 2.81365 6.96735L8.25372 9.39032C8.65291 9.56671 9.15421 9.65954 9.65551 9.65954C10.1568 9.65954 10.6581 9.56671 11.0573 9.39032L16.4974 6.96735C17.8713 6.35465 18.0756 5.51915 18.0756 5.07354C18.0756 4.62794 17.8806 3.79243 16.4974 3.17973Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.65551 14.4591C9.30275 14.4591 8.94998 14.3848 8.62506 14.2455L2.36805 11.4605C1.41186 11.0335 0.669189 9.89162 0.669189 8.8426C0.669189 8.46198 0.975541 8.15563 1.35616 8.15563C1.73678 8.15563 2.04313 8.46198 2.04313 8.8426C2.04313 9.3439 2.46088 9.99374 2.92505 10.198L9.18206 12.983C9.47913 13.113 9.82262 13.113 10.1197 12.983L16.3767 10.198C16.8409 9.99374 17.2586 9.35319 17.2586 8.8426C17.2586 8.46198 17.565 8.15563 17.9456 8.15563C18.3262 8.15563 18.6326 8.46198 18.6326 8.8426C18.6326 9.88234 17.8899 11.0335 16.9337 11.4605L10.6767 14.2455C10.3611 14.3848 10.0083 14.4591 9.65551 14.4591Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.65551 19.0636C9.30275 19.0636 8.94998 18.9893 8.62506 18.8501L2.36805 16.0651C1.33759 15.6102 0.669189 14.5797 0.669189 13.4472C0.669189 13.0665 0.975541 12.7602 1.35616 12.7602C1.73678 12.7602 2.04313 13.0665 2.04313 13.4472C2.04313 14.032 2.38662 14.5612 2.92505 14.8025L9.18206 17.5876C9.47913 17.7175 9.82262 17.7175 10.1197 17.5876L16.3767 14.8025C16.9058 14.5705 17.2586 14.032 17.2586 13.4472C17.2586 13.0665 17.565 12.7602 17.9456 12.7602C18.3262 12.7602 18.6326 13.0665 18.6326 13.4472C18.6326 14.5797 17.9642 15.6009 16.9337 16.0651L10.6767 18.8501C10.3611 18.9893 10.0083 19.0636 9.65551 19.0636Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var StackIcon_default = StackIcon;

export {
  StackIcon_default
};
